import { FormCheckboxComponent } from './form-checkbox/form-checkbox.component'
import { FormDatepickerInputComponent } from './form-datepicker-input/form-datepicker-input.component'
import { FormDaterangeInputComponent } from './form-daterange-input/form-daterange-input.component'
import { FormFieldAffixComponent } from './form-field-affix/form-field-affix.component'
import { FormFieldRenderComponent } from './form-field-render/form-field-render.component'
import { FormFieldComponent } from './form-field/form-field.component'
import {
  FormFieldLabelDirective,
  FormFieldPrefixDirective,
  FormFieldSuffixDirective,
  FormFieldErrorDirective,
} from './form-field/form-field.directive'
import { FormInputComponent } from './form-input/form-input.component'
import { CustomInputDirective } from './form-input/form-input.directive'
import { FormMultiSelectComponent } from './form-multi-select/form-multi-select.component'
import {
  MultiSelectOptionLabelDirective,
  MultiSelectSelectedLabelDirective,
} from './form-multi-select/form-multi-select.directive'
import { FormRadioComponent } from './form-radio/form-radio.component'
import { FormRadioGroupDirective } from './form-radio/form-radio.directive'
import { FormRangeComponent } from './form-range/form-range.component'
import { FormSelectComponent } from './form-select/form-select.component'
import { SelectOptionItemDirective, SelectItemLabelDirective } from './form-select/form-select.directive'
import { FormSwitchComponent } from './form-switch/form-switch.component'
import { FormTagsComponent } from './form-tags/form-tags.component'
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component'
import { MatFormField2Component } from './mat-form-field2/mat-form-field2.component'
import { SelectComponent } from './mat-select-search/select/select.component'
import { SelectSearchComponent } from './mat-select-search/select-search/select-search.component'
import { CountrySelectComponent } from './country-select/country-select.component'
import { CurrencySelectComponent } from './currency-select/currency-select.component'
import { TimezoneSelectComponent } from './timezone-select/timezone-select.component'
import {
  SelectActionButtonDirective,
  SelectItemDirective,
  SelectLabelDirective,
} from './mat-select-search/select/select.directives'
import { LanguageSelectComponent } from './language-select/language-select.component'
import { MatDateRangeInputComponent } from './mat-daterange-input/mat-daterange-input.component'
import { FormTags2Component } from './form-tags2/form-tags2.component'
import { DatePickerComponent } from './date-picker/date-picker.component'
import { MatDateInputComponent } from './mat-date-input/mat-date-input.component'
import { DateInputValidatorDirective } from './mat-date-input/mat-date-input.validator'
import { DaterangeInputOverlapValidatorDirective } from './mat-daterange-input/mat-daterange-overlapping.validator'
import { MatHTMLInputComponent } from './mat-html-input/mat-html-input.component'

export * from './form-checkbox/form-checkbox.component'
export * from './form-datepicker-input/form-datepicker-input.component'
export * from './form-daterange-input/form-daterange-input.component'
export * from './form-field-affix/form-field-affix.component'
export * from './form-field-render/form-field-render.component'
export * from './form-field/form-field.component'
export * from './form-field/form-field.directive'
export * from './form-input/form-input.component'
export * from './form-input/form-input.directive'
export * from './form-multi-select/form-multi-select.component'
export * from './form-multi-select/form-multi-select.directive'
export * from './form-radio/form-radio.component'
export * from './form-radio/form-radio.directive'
export * from './form-range/form-range.component'
export * from './form-select/form-select.component'
export * from './form-select/form-select.directive'
export * from './form-switch/form-switch.component'
export * from './form-tags/form-tags.component'
export * from './form-tags2/form-tags2.component'
export * from './date-range-picker/date-range-picker.component'
export * from './mat-daterange-input/mat-daterange-input.component'
export * from './date-picker/date-picker.component'
export * from './mat-date-input/mat-date-input.component'
export * from './mat-form-field2/mat-form-field2.component'
export * from './mat-select-search/select/select.component'
export * from './mat-select-search/select-search/select-search.component'
export * from './country-select/country-select.component'
export * from './currency-select/currency-select.component'
export * from './timezone-select/timezone-select.component'
export * from './mat-select-search/select/select.directives'
export * from './language-select/language-select.component'
export * from './mat-html-input/mat-html-input.component'

export const formComponents = [
  FormFieldLabelDirective,
  FormFieldPrefixDirective,
  FormFieldSuffixDirective,
  FormFieldErrorDirective,
  FormFieldRenderComponent,
  FormFieldAffixComponent,

  FormFieldComponent,

  CustomInputDirective,
  FormInputComponent,

  FormSelectComponent,
  SelectOptionItemDirective,
  SelectItemLabelDirective,

  MultiSelectOptionLabelDirective,
  MultiSelectSelectedLabelDirective,
  FormMultiSelectComponent,

  FormSwitchComponent,
  FormRadioGroupDirective,
  FormRadioComponent,
  FormCheckboxComponent,
  FormDatepickerInputComponent,
  FormDaterangeInputComponent,
  DateInputValidatorDirective,
  DaterangeInputOverlapValidatorDirective,

  DateRangePickerComponent,
  MatDateRangeInputComponent,

  DatePickerComponent,
  MatDateInputComponent,

  FormRangeComponent,

  FormTagsComponent,
  FormTags2Component,

  MatHTMLInputComponent,

  MatFormField2Component,

  SelectSearchComponent,
  SelectComponent,
  SelectLabelDirective,
  SelectItemDirective,
  SelectItemLabelDirective,
  SelectOptionItemDirective,
  SelectActionButtonDirective,

  CountrySelectComponent,
  CurrencySelectComponent,
  TimezoneSelectComponent,
  LanguageSelectComponent,
]
